export default __webpack_public_path__ + "static/media/program_intro_3.8ce070b6.png";